

module.exports = __webpack_require__.stylable.create(
    "SkeletonGroup1875690256",
    {"classes":{"root":"SkeletonGroup1875690256__root","animator":"SkeletonGroup1875690256__animator"},"vars":{"color":"--SkeletonGroup1875690256-color"},"stVars":{},"keyframes":{"wave":"SkeletonGroup1875690256__wave"}},
    ".SkeletonGroup1875690256__root{--SkeletonGroup1875690256-color:#FFFFFF;overflow:hidden;position:relative}.SkeletonGroup1875690256__animator{position:absolute;left:-200px;top:0;height:100%;width:200px;background:linear-gradient(to right,transparent 0%,var(--SkeletonGroup1875690256-color, #FFFFFF) 40%,var(--SkeletonGroup1875690256-color, #FFFFFF) 60%,transparent 100%);animation:SkeletonGroup1875690256__wave 1s ease .5s infinite;opacity:.2}@keyframes SkeletonGroup1875690256__wave{0%{left:-200px}to{left:100%}}",
    2,
    "SkeletonGroup1875690256",
    __webpack_require__.stylable.$
);
